import { render, staticRenderFns } from "./BookingServiceForm.vue?vue&type=template&id=95c1bf0e&scoped=true"
import script from "./BookingServiceForm.vue?vue&type=script&lang=js"
export * from "./BookingServiceForm.vue?vue&type=script&lang=js"
import style0 from "./BookingServiceForm.vue?vue&type=style&index=0&id=95c1bf0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c1bf0e",
  null
  
)

export default component.exports